import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error?.message ?? error, error?.stack, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      const e = this.state.error;
      const msg = e?.message || '';
      const isStaleBundle = msg.includes('Failed to fetch dynamically imported module');
      return (
        <div style={{ padding: '2rem', fontFamily: 'sans-serif', maxWidth: '600px' }}>
          <h2>Something went wrong</h2>
          <p><strong>{msg || 'Unknown error'}</strong></p>
          {isStaleBundle && (
            <p style={{ marginTop: '1rem' }}>
              The app was updated. Please reload the page to load the latest version.
            </p>
          )}
          {isStaleBundle && (
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{ marginTop: '0.75rem', padding: '8px 16px', cursor: 'pointer' }}
            >
              Reload page
            </button>
          )}
          <pre style={{ overflow: 'auto', fontSize: '12px', background: '#f5f5f5', padding: '1rem', marginTop: '1rem' }}>
            {e?.stack || ''}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
